import { postAsync } from "./http-client";

const AuthApi = {
  login: async (data) => {
    return await postAsync("/ceo/account/login", data);
  },

  forgetId: async (data) => {
    return await postAsync("/ceo/account/forgetId", data);
  },
  forgetPassword: async (data) => {
    return await postAsync("/ceo/account/forgetPassword", data);
  },
  verifyOtpId: async (data) => {
    return await postAsync("/ceo/account/verifyOtpId", data);
  },
  verifyOtpPassword: async (data) => {
    return await postAsync("/ceo/account/verifyOtpPassword", data);
  },
  changePassword: async (data) => {
    return await postAsync("/ceo/account/changePassword", data);
  },
  logout: async () => {
    return await postAsync("/ceo/account/logout");
  },

};
export default AuthApi;
